import { SectionTerminoCondiciones } from "../components/SectionTerminoCondiciones/SectionTerminoCondiciones";
import { SectionPromocionesYCampanas } from "../components/SectionPromocionesYCampanas/SectionPromocionesYCampanas";
import React, { useState } from "react";

class ScrollToTopOnMount extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}

export function TerminosCondiciones () {
  const [activeTab, setActiveTab] = useState("terminos");

  const tabStyle = (tab) => ({
    width: "auto",
    padding: "0 28px",
    color: activeTab === tab ? "#000081" : "#000081",
    borderBottom: activeTab === tab ? "3px solid #000081" : "3px solid transparent",
    fontWeight: activeTab === tab ? "bold" : "normal",
  });

  return <>
    <ScrollToTopOnMount />
    <section className="section section-terminoHero">
      <div className="container" style={{ display: "flex", justifyContent: "center" }}>
        <p
          className="container-tabs__buttons"
          style={tabStyle("terminos")}
          onClick={() => setActiveTab("terminos")}
        >
          Términos y Condiciones
        </p>
        <p
          className="container-tabs__buttons"
          style={tabStyle("promociones")}
          onClick={() => setActiveTab("promociones")}
        >
          Promociones y Campañas
        </p>
      </div>
    </section>
    <div>
      <div style={{ display: activeTab === "terminos" ? "block" : "none" }}>
        <SectionTerminoCondiciones />
      </div>
      <div style={{ display: activeTab === "promociones" ? "block" : "none" }}>
        <SectionPromocionesYCampanas />
      </div>
    </div>
  </>;
}
